import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { Header } from '../../components'

import { getRouteDefinition } from '../../utils/routes'

import {
  generateUids,
  clearUserCareerPathRole,
  clearUserData
} from '../../actions'

class HeaderContainer extends Component {
  constructor(props) {
    super(props)
    const { location } = props
    const route = getRouteDefinition(location.pathname)

    this.state = {
      route,
      sharedReport: route.path === '/report/:uuid/:suid'
    }
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props

    if (prevProps.location.pathname !== location.pathname) {
      const route = getRouteDefinition(location.pathname)
      this.setState({
        route,
        sharedReport: route.path === '/report/:uuid/:suid'
      })
    }
  }

  backAction = () => {
    const { history, location, startOver } = this.props

    if (location.pathname === '/report') {
      startOver()
      history.replace('/career-explorer/career-path')
    } else if (location.pathname !== '/') {
      history.goBack()
    }
  }

  startOver = () => {
    this.props.startOver()
    this.props.history.replace('/')
  }

  pageTitle = () => {
    const { route, sharedReport } = this.state
    const { report } = this.props

    console.log(route)

    if (sharedReport)
      return report.firstName
        ? `${report.firstName}'s career path | Career Mapper`
        : 'career path | Career Mapper'

    return route.name === 'Career Mapper'
      ? 'Career Mapper'
      : `${route.name} | Career Mapper`
  }

  pageHeader = () => {
    const { route, sharedReport } = this.state
    const { report } = this.props

    switch (true) {
      case sharedReport:
        return (
          <Header
            title={report.firstName ? `${report.firstName}'s career path` : ''}
            showShareButton={false}
            showBackButton={false}
          />
        )
      case route.path === '/':
        return (
          <Header
            title={route.name}
            showShareButton={false}
            showBackButton={false}
          />
        )

      case route.path === '/career-explorer/career-path':
        return (
          <Header
            backAction={() => {
              this.props.callClearUserData()
              this.props.history.replace('/')

              window.dataLayer.push({
                event: "startOver",
                startOverOrigin: "career-path"
              })
            }}
            buttonIcon='undo'
            title={'What job would you like to do next?'}
            className='header--button-right'
          />
        )
      case route.path.includes('/career-explorer/career-path/detail/'):
        return (
          <Header
            backAction={this.backAction}
            title={'Tell us what skills you have'}
          />
        )
      default:
        return <Header backAction={this.backAction} title={route.name || ''} />
    }
  }

  render = () => (
    <>
      <Helmet>
        <title>{this.pageTitle()}</title>
      </Helmet>

      {this.pageHeader()}

      {false && (
        <p className='g--font-body'>
          Please check something before proceeding.
        </p>
      )}
    </>
  )
}

HeaderContainer.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  report: state.report || {}
})

const mapDispatchToProps = dispatch => ({
  startOver: () => {
    dispatch(generateUids(true))
    dispatch(clearUserCareerPathRole(0))
  },
  callClearUserData: () => {
    dispatch(clearUserData())
    dispatch(generateUids(true))
  }
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderContainer)
)
